export default __webpack_public_path__ + "static/media/st-kitts-and-nevis.187dc622.png";